export default () => ({
  /** @type {{ [key: string]: import('src/models/Device').default }} */
  devices: {},
  /** @type {Promise<import('src/models/Device').default[]>} */
  devicesPromise: null,
  disconnectedLocationHistory: {},
});
